document.addEventListener("DOMContentLoaded", function () {
    const localData = sessionStorage.getItem("subscribe-popup")
    if (localData) {
      return
    }
    if (this.location.search === "?customer_posted=true#subscribePopup") {
      const el = document.querySelector(".subscribe-popup")
      sessionStorage.setItem("subscribe-popup", "true")
      el.classList.add("active")
      init = true
      return
    }
    let init = false
    window.addEventListener("scroll", function () {
      if (init || localData) {
        return
      }
  
      init = true
  
      const el = document.querySelector(".subscribe-popup")
      if (el && !el.classList.contains('active')) {
        const timeout = el.dataset.delay
        setTimeout(function () {
          el.classList.add("active")
        }, timeout)
      }
    })
  
    document.querySelector(".subscribe-popup__overlay").addEventListener("click", function (e) {
      if (e.target.classList.contains("subscribe-popup__overlay")) {
        const el = e.target.closest(".subscribe-popup")
        el.classList.remove("active")
        sessionStorage.setItem("subscribe-popup", "true")
      }
    })
  
    document.querySelector(".subscribe-popup-box-close").addEventListener("click", function (e) {
      const el = e.target.closest(".subscribe-popup")
      el.classList.remove("active")
    })
  })